import { extend } from 'flarum/common/extend';
import app from 'flarum/forum/app';
import Button from 'flarum/common/components/Button';
import interceptAuthPrompts from './intercept-auth-prompts';
import { getOidcLoginUrl, redirectToOidcLogin } from './redirect';
export const FEATURE_ID = 'oidc-login';
function isGuest() {
  return !app.session.user;
}

/**
 * Replace the header login button and redirect guests to OIDC
 * without opening the Flarum LogInModal.
 */
export default function registerOidcLogin() {
  if (!getOidcLoginUrl()) {
    return;
  }
  interceptAuthPrompts();
  extend('flarum/forum/components/HeaderSecondary', 'items', function (items) {
    if (!isGuest() || !items.has('logIn')) {
      return;
    }
    items.setContent('logIn', m(Button, {
      className: "Button Button--link",
      onclick: redirectToOidcLogin
    }, app.translator.trans('core.forum.header.log_in_link')));
  });
}
flarum.reg.add('dia-theme', 'forum/features/oidc-login', registerOidcLogin);